import { cx } from "class-variance-authority"
import { type ComponentPropsWithRef, forwardRef, memo } from "react"

interface ViewContainerProps extends ComponentPropsWithRef<"div"> {
	maxWidth?: "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl" | "none"
}

export const ViewContainer = memo(
	forwardRef<HTMLDivElement, ViewContainerProps>((props, ref) => {
		const { children, className, maxWidth = "none", ...rest } = props

		return (
			<div
				className={cx("bg-(--color-background) relative flex size-full justify-center", className)}
				ref={ref}
				{...rest}
			>
				<div
					className={cx("size-full overflow-auto p-4", {
						"max-w-xl": maxWidth === "xl",
						"max-w-2xl": maxWidth === "2xl",
						"max-w-3xl": maxWidth === "3xl",
						"max-w-4xl": maxWidth === "4xl",
						"max-w-5xl": maxWidth === "5xl",
						"max-w-6xl": maxWidth === "6xl",
						"max-w-7xl": maxWidth === "7xl",
					})}
				>
					{children}
				</div>
			</div>
		)
	}),
)
